import { useTranslation } from 'react-i18next';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  ChartBlock,
  Stack,
  Text,
} from '@shared/ui';

function ChartBlockPlaceholder() {
  return (
    <div className="flex h-56 items-center justify-center rounded-md border border-dashed border-border bg-muted/20">
      <Text size="sm" color="muted">
        Chart content
      </Text>
    </div>
  );
}

export function ChartBlockShowcase() {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('uiLibrary.dataDisplay.chartBlock.title', 'Chart Block')}</CardTitle>
        <CardDescription>
          {t(
            'uiLibrary.dataDisplay.chartBlock.description',
            'Standard chart container with a title and chart body.'
          )}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Stack gap="lg">
          <ChartBlock
            title={t(
              'uiLibrary.dataDisplay.chartBlock.examples.titleOnly',
              'Registrations by Course Type'
            )}
            headerMode="title-only"
          >
            <ChartBlockPlaceholder />
          </ChartBlock>
          <ChartBlock
            title={t('uiLibrary.dataDisplay.chartBlock.examples.full', 'Movement Revenue and Goal')}
            description={t(
              'uiLibrary.dataDisplay.chartBlock.examples.fullDescription',
              'Full header variant with title and subtitle.'
            )}
            headerMode="full"
          >
            <ChartBlockPlaceholder />
          </ChartBlock>
        </Stack>
      </CardContent>
    </Card>
  );
}
